import {
  Typography,
  Fade,
  Modal,
  FormControl,
  FormControlLabel,
  Radio,
  makeStyles,
  RadioGroup,
} from "@material-ui/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
const styles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 20,
  },
  paper: {
    backgroundColor: "#fff",
    boxShadow: theme.shadows[5],
    padding: 20,
    textAlign: "left",
  },
  modalInner: {
    width: 600,
    borderRadius: 10,
    maxHeight: 500,
    overflow: "auto",
  },
  headerStyle: {
    color: theme.palette.primary.main,
    textAlign: "left",
  },
}));

const RoleModal = (roleModalProps) => {
  const classes = styles();
  const { open, onClose, roleModalSelection, history } = roleModalProps;
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={onClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <div className={`${classes.paper} ${classes.modalInner}`}>
          <Typography variant="h1" className={classes.headerStyle}>
            Choose Role
          </Typography>
          <FormControl
            component="fieldset"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            <RadioGroup
              aria-label="role"
              name="role"
              onChange={(event) =>
                history.push("CoachDetail", {
                  id: roleModalSelection.coach_id,
                  coachType: "external",
                  currentSelection: roleModalSelection,
                  selectedRole: event.target.value,
                })
              }
            >
              {roleModalSelection?.coach_roles
                ?.filter((el) =>
                  [
                    "Assessor",
                    "Executive Coach",
                    "Mediator",
                    "Facilitator",
                    "Mentor",
                  ].includes(el)
                )
                .map((option) => {
                  return (
                    <FormControlLabel
                      style={{ textTransform: "capitalize" }}
                      value={option}
                      control={<Radio />}
                      label={
                        <Typography variant="subtitle1">{option}</Typography>
                      }
                    />
                  );
                })}
            </RadioGroup>
          </FormControl>
        </div>
      </Fade>
    </Modal>
  );
};
const CoachNameRender = ({ rowData }) => {
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [roleModalSelection, setRoleModalSelection] = useState({});
     const globaluserData = useSelector((state) => state.commonReducer);
     const role = globaluserData?.role;
  // const role = sessionStorage.getItem("role");
  const history = useHistory();

  return (
    <>
      {role === "admin" ? (
        <Typography
          onClick={() => {
            const filteredRolesList = rowData?.coach_roles.filter((el) => {
              return [
                "Assessor",
                "Executive Coach",
                "Mediator",
                "Facilitator",
                "Mentor",
              ].includes(el);
            });
            if (filteredRolesList.length > 1) {
              setIsRoleModalOpen(true);
              setRoleModalSelection(rowData);
            } else {
              history.push("CoachDetail", {
                id: rowData.coach_id,
                coachType: "external",
                currentSelection: rowData,
                selectedRole: filteredRolesList[0],
              });
            }
          }}
          // color="primary"
          style={{
            textTransform: "none",
            cursor: "pointer",
            fontSize: "16px",
            fontFamily: "open sans",
          }}
        >
          {rowData?.coach_name || ""}
        </Typography>
      ) : (
        <Typography style={{ fontSize: "16px" }}>
          {rowData?.coach_name || ""}
        </Typography>
      )}
      <RoleModal
        open={isRoleModalOpen}
        roleModalSelection={roleModalSelection}
        onClose={() => {
          setIsRoleModalOpen(false);
          setRoleModalSelection({});
        }}
        history={history}
      />
    </>
  );
};
export default CoachNameRender;
